<template>
  <div
    class="review-bar-container d-flex"
    :class="{
      'disabled': isDisabled,
      'active': isActive,
    }"
    @click="reviewBarClicked"
  >
    <div class="label d-flex align-items-center">
      {{ starCount }} {{ starCount === 1 ? $t('review_star') : $t('review_stars') }}
    </div>
    <div
      class="bar"
      :style="'--review-percentage:' + percent + '%'"
    />
    <div class="label d-flex align-items-center justify-content-end" v-text="percent + ' %'" />
  </div>
</template>

<script>
export default {
  name: 'ReviewBar',
  props: {
    /**
     * Csillag
     */
    starCount: {
      type: Number,
      required: true,
    },
    /**
     * Százalék
     */
    percent: {
      type: Number,
      required: true,
    },
    /**
     * Disabled-e
     */
    isDisabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Aktív-e
     */
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    reviewBarClicked() {
      if (this.isDisabled) {
        return
      }
      this.$emit('reviewBarClicked', this.starCount)
    },
  },
}
</script>

<style lang="scss" scoped>
.review-bar-container {
  padding: 15px 5px;

  &.disabled {
    opacity: .35;
    filter: grayscale(1);
  }

  &.active {
    background-color: var(--item-review-bar-active-background-color);
  }

  .label {
    white-space: nowrap;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    min-width: 128px;

    @media screen and (max-width: 768px) {
      min-width: 80px; // TODO: 72px kéne legyen, de a font nem oke
      font-size: 14px;
      line-height: 16px;
    }
  }

  .bar {
    max-width: 520px;
    width: 100%;
    height: 24px;
    background: linear-gradient(to right, var(--item-review-bar-filled-color) var(--review-percentage), var(--item-review-bar-unfilled-color) 0%);
  }
}
</style>
